export const rateSheetURL = '/assets/data/savings-rates.xml'


// WEBPACK FOOTER //
// ./src/config.js